import React from 'react';
import { Link } from 'react-router-dom';
import { FaCrown, FaShieldAlt, FaArrowLeft } from 'react-icons/fa';
import { getCurrentUser } from '../../utils/authSession';
import '../../pages/super/superPanel.css';

export default function SuperPanelShell({
  title,
  titleExtra,
  subtitle,
  breadcrumb,
  action,
  children,
  showBack = false,
}) {
  const user = getCurrentUser();

  return (
    <div className="sp-shell">
      <div className="sp-ambient" aria-hidden="true" />
      <div className="sp-grid-overlay" aria-hidden="true" />

      <header className="sp-hero">
        <div className="sp-hero-top">
          <Link to="/" className="sp-back-admin">
            <FaArrowLeft size={12} />
            Back to Admin
          </Link>
          <div className="sp-hero-badge">
            <FaCrown className="sp-hero-badge-icon" />
            <span>Root Access</span>
          </div>
        </div>

        <div className="sp-hero-main">
          <div className="sp-hero-emblem">
            <FaShieldAlt />
            <span className="sp-hero-ring" />
            <span className="sp-hero-ring sp-hero-ring--delay" />
          </div>
          <div className="sp-hero-text">
            <p className="sp-hero-kicker">Al-Burak Scents</p>
            <h1 className="sp-hero-title">SUPER PANEL</h1>
            <p className="sp-hero-sub">
              {subtitle || 'Full system control — manage admins, roles & access'}
            </p>
          </div>
          <div className="sp-hero-user">
            <div className="sp-hero-avatar">
              {(user?.name || 'S').charAt(0).toUpperCase()}
            </div>
            <div>
              <p className="sp-hero-user-name">{user?.name || 'Super Admin'}</p>
              <p className="sp-hero-user-role">Super Administrator</p>
            </div>
          </div>
        </div>

        <div className="sp-hero-bottom">
          <div className="sp-page-head">
            <div>
              {showBack && (
                <button type="button" className="sp-inline-back" onClick={() => window.history.back()}>
                  ← Back
                </button>
              )}
              <h2 className="sp-page-title">
                {title}
                {titleExtra}
              </h2>
              {breadcrumb && <p className="sp-breadcrumb">{breadcrumb}</p>}
            </div>
            {action && <div className="sp-page-action">{action}</div>}
          </div>
        </div>
      </header>

      <div className="sp-body">{children}</div>
    </div>
  );
}
